import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { postRequest } from "../../../constants/api";
import { Loader, SearchBar } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Colors } from "../../../constants/styles";
import { formatDate } from "../../../constants/helper";
import {
  Box,
  Paper,
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahLelangBulanan = () => {
  const screenSize = useScreenWidth();
  const [isFetchError, setIsFetchError] = useState(false);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  // Angsuran
  const [angsuranKelompokId, setAngsuranKelompokId] = useState("");
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [tglLelang, setTglLelang] = useState("");
  const [minimalLelang, setMinimalLelang] = useState("");
  const [nominal, setNominal] = useState("");

  const [kelompoks, setKelompoks] = useState([]);

  const [kelompokId, setKelompokId] = useState("");
  const [noKelompok, setNoKelompok] = useState("");

  const [openKelompok, setOpenKelompok] = useState(false);
  const [searchTermKelompok, setSearchTermKelompok] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [angsuranKelompoks, setAngsuranKelompoks] = useState([]);
  const [openAngsuranKelompok, setOpenAngsuranKelompok] = useState(false);
  const [searchTermAngsuranKelompok, setSearchTermAngsuranKelompok] =
    useState("");
  let [pageAngsuranKelompok, setPageAngsuranKelompok] = useState(0);
  const [limitAngsuranKelompok, setLimitAngsuranKelompok] = useState(1000);
  const [pagesAngsuranKelompok, setPagesAngsuranKelompok] = useState(0);
  const [rowsAngsuranKelompok, setRowsAngsuranKelompok] = useState(0);
  const [queryAngsuranKelompok, setQueryAngsuranKelompok] = useState("");

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermKelompok(query);
  };

  const handleClickOpenKelompok = () => {
    setOpenKelompok(true);
  };

  const handleCloseKelompok = () => {
    setOpenKelompok(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeAngsuranKelompok = (e, p) => {
    setPageAngsuranKelompok(p - 1);
  };

  const searchDataAngsuranKelompok = (e) => {
    e.preventDefault();
    setPageAngsuranKelompok(0);
    setSearchTermAngsuranKelompok(query);
  };

  const handleClickOpenAngsuranKelompok = () => {
    setOpenAngsuranKelompok(true);
  };

  const handleCloseAngsuranKelompok = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAngsuranKelompok(false);
  };

  useEffect(() => {
    getKelompoksFirstTime();
  }, []);

  useEffect(() => {
    getKelompoks();
  }, [page, searchTermKelompok]);

  useEffect(() => {
    if (kelompokId !== "") {
      getAngsuranKelompoksByKelompok();
    }
  }, [kelompokId, pageAngsuranKelompok, searchTermAngsuranKelompok]);

  const getKelompoks = async () => {
    const response = await postRequest(
      `/kelompoksBelumLunasPagination?search_query=${searchTermKelompok}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch,
    );
    setQuery(searchTermKelompok);
    setKelompoks(response.data.kelompoks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getKelompoksFirstTime = async () => {
    const response = await postRequest(
      `/kelompoksBelumLunasPagination?search_query=${searchTermKelompok}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch,
    );
    setQuery(searchTermKelompok);
    setKelompoks(response.data.kelompoks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getAngsuranKelompoksByKelompok = async () => {
    const response = await postRequest(
      `/angsuranKelompoksByKelompokBlmPenetapanPemenangPagination?search_query=${searchTermAngsuranKelompok}&page=${pageAngsuranKelompok}&limit=${limitAngsuranKelompok}`,
      {
        kelompokId,
      },
      navigate,
      dispatch,
    );
    setQueryAngsuranKelompok(searchTermAngsuranKelompok);
    setAngsuranKelompoks(response.data.angsuranKelompoks);
    setPageAngsuranKelompok(response.data.page);
    setPagesAngsuranKelompok(response.data.totalPage);
    setRowsAngsuranKelompok(response.data.totalRows);
  };

  const saveLelangBulanan = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);

        const response = await postRequest(
          `/saveLelangBulanan`,
          {
            angsuranKelompokId,
            kelompokId,
            no,
            tglLelang,
            minimalLelang,
            nominal,
          },
          navigate,
          dispatch,
        );
        setLoading(false);
        navigate("/lelangBulanan");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Lelang</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Lelang Bulanan</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveLelangBulanan}>
        <Card>
          <Card.Header>Lelang Bulanan</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    No. Kelompok <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      value={noKelompok}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenKelompok()}
                      isInvalid={noKelompok.length === 0 && true}
                    />
                    <Form.Control.Feedback type="invalid">
                      No. Kelompok harus diisi!
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    No. Angsuran <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      value={no}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenAngsuranKelompok()}
                      isInvalid={no.length === 0 && true}
                    />
                    <Form.Control.Feedback type="invalid">
                      No. Angsuran harus diisi!
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Tgl. Jatuh Tempo :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={tglJatuhTempo} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Tgl. Lelang <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      customInput={<Form.Control required />}
                      selected={tglLelang}
                      onChange={(date) => {
                        setTglLelang(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Minimal Lelang <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={minimalLelang}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setMinimalLelang(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, ""),
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nominal <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={nominal}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setNominal(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, ""),
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/lelangBulanan")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>

      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openKelompok}
        onClose={handleCloseKelompok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Kelompok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Kelompok
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Tgl.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {kelompoks.map((user, index) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setNoKelompok(user.noKelompok);
                        setKelompokId(user.id);

                        handleCloseKelompok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {user.noKelompok}
                      </TableCell>
                      <TableCell>{formatDate(user.tglKelompok)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAngsuranKelompok}
        onClose={handleCloseAngsuranKelompok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Angsuran Kelompok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataAngsuranKelompok}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryAngsuranKelompok}
                  setSearchTerm={setQueryAngsuranKelompok}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No.
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Tgl. Jatuh Tempo
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {angsuranKelompoks.map((user, index) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setNo(user.no);
                        setAngsuranKelompokId(user.id);
                        setTglJatuhTempo(formatDate(user.tglJatuhTempo));

                        // console.log(user);
                        // console.log("user.kelompok.patokanHarga");
                        // console.log(user.kelompok.patokanHarga);

                        // Hitung Minimal Lelang
                        let patokanHarga = user.kelompok.patokanHarga;
                        let potonganPersenAdmin = 0;
                        let potonganAdmin = 0;
                        let subtotal = 0;
                        let totalAngsuran = user.kelompok.totalAngsuran;
                        let limitMurni = 0;
                        let bayangan =
                          (totalAngsuran * user.kelompok.patokanBayangan) / 100;
                        let limitLelang = 0;

                        if (parseInt(user.no) >= 1 && parseInt(user.no) <= 12) {
                          potonganPersenAdmin = 4.5;
                          potonganAdmin =
                            (patokanHarga * potonganPersenAdmin) / 100;
                          subtotal = patokanHarga + potonganAdmin;

                          limitMurni = subtotal - totalAngsuran;
                          limitLelang = limitMurni + bayangan;
                          setMinimalLelang(limitLelang);
                        } else if (
                          parseInt(user.no) >= 13 &&
                          parseInt(user.no) <= 24
                        ) {
                          potonganPersenAdmin = 4.25;
                          potonganAdmin =
                            (patokanHarga * potonganPersenAdmin) / 100;
                          subtotal = patokanHarga + potonganAdmin;

                          limitMurni = subtotal - totalAngsuran;
                          limitLelang = limitMurni + bayangan;
                          setMinimalLelang(limitLelang);
                        } else if (
                          parseInt(user.no) >= 25 &&
                          parseInt(user.no) <= 26
                        ) {
                          potonganPersenAdmin = 4;
                          potonganAdmin =
                            (patokanHarga * potonganPersenAdmin) / 100;
                          subtotal = patokanHarga + potonganAdmin;

                          limitMurni = subtotal - totalAngsuran;
                          limitLelang = limitMurni + bayangan;
                          setMinimalLelang(limitLelang);
                        } else {
                          potonganPersenAdmin = 4;
                          potonganAdmin =
                            (patokanHarga * potonganPersenAdmin) / 100;
                          let penurunan = 0;
                          if (parseInt(user.no) === 27) {
                            penurunan = 15;
                          } else if (parseInt(user.no) === 28) {
                            penurunan = 24;
                          } else if (parseInt(user.no) === 29) {
                            penurunan = 33;
                          } else if (parseInt(user.no) === 30) {
                            penurunan = 42;
                          } else if (parseInt(user.no) === 31) {
                            penurunan = 47;
                          } else if (parseInt(user.no) === 32) {
                            penurunan = 53;
                          } else if (parseInt(user.no) === 33) {
                            penurunan = 58;
                          } else if (parseInt(user.no) === 34) {
                            penurunan = 65;
                          } else if (parseInt(user.no) === 35) {
                            penurunan = 73;
                          } else if (parseInt(user.no) === 36) {
                            penurunan = 80;
                          }
                          potonganAdmin =
                            potonganAdmin - (potonganAdmin * penurunan) / 100;
                          subtotal = patokanHarga + potonganAdmin;

                          limitMurni = subtotal - totalAngsuran;
                          limitLelang = limitMurni + bayangan;
                          setMinimalLelang(limitLelang);
                        }
                        // console.log("potonganAdmin");
                        // console.log(potonganAdmin);
                        // console.log("subtotal");
                        // console.log(subtotal);
                        // console.log("totalAngsuran");
                        // console.log(totalAngsuran);
                        // console.log("limitMurni");
                        // console.log(limitMurni);
                        // console.log("bayangan");
                        // console.log(bayangan);
                        // console.log("limitLelang");
                        // console.log(limitLelang);

                        handleCloseAngsuranKelompok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {user.no}
                      </TableCell>
                      <TableCell>{formatDate(user.tglJatuhTempo)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesAngsuranKelompok}
                page={pageAngsuranKelompok + 1}
                onChange={handleChangeAngsuranKelompok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahLelangBulanan;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};
